import { render, staticRenderFns } from "./MultipleManualMatching.vue?vue&type=template&id=195fa709&"
import script from "./MultipleManualMatching.vue?vue&type=script&lang=js&"
export * from "./MultipleManualMatching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports